import React from "react";

const PageLoader = ({ message = "Loading data...", fullPage = false }) => {
  const content = (
    <div className="flex flex-col items-center justify-center gap-4 animate-in fade-in duration-500">
      <div className="relative">
        <div className="h-12 w-12 rounded-full border-4 border-slate-200" />
        <div className="absolute top-0 h-12 w-12 animate-spin rounded-full border-4 border-emerald-500 border-t-transparent" />
      </div>
      <p className="text-sm font-bold tracking-widest text-slate-400 uppercase">
        {message}
      </p>
    </div>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/20 backdrop-blur-sm">
        <div className="rounded-3xl bg-white p-12 shadow-2xl ring-1 ring-slate-200">
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 items-center justify-center py-24">
      {content}
    </div>
  );
};

export default PageLoader;
